// Prijenos dokumenta u kasu (Fiskalizacija 1.0).
//
// Kasa vodi racune u vlastitoj tablici "Pos" i ne poznaje strukturu dokumenta,
// pa se dokument ovdje prevede u ono sto kasa cita: stavke s BRUTO cijenom po
// komadu i kupca.
//
// ZASTO izdvojeno: isti prijenos sada pokrecu dva ekrana - dijalog kopiranja
// (ponuda -> kasa) i servisni nalog ("U KASU" jednim klikom). Dvije kopije
// istog prevodjenja bi se razisle, a greska bi se vidjela tek na racunu.

import { parseNum } from '@/snippets/allSnippets'

/**
 * Stavke i kupac za kasu.
 *
 * @param {Object} p
 *   document        glava dokumenta
 *   stavke          stavke dokumenta (DocumentDetails)
 *   documentSide    strana dokumenta (1 primka, 2 izdatnica, 3 ponuda)
 *   izvorNaziv      naziv izvora za napomenu racuna ("Ponuda 1", "Servisni nalog 7")
 *   bezOznakeIzvora true = cisti kopi, bez napomene odakle je
 * @returns {Object} {stavke, kupac, izvor} ili {greska}
 */
export const pripremiKasaPrijenos = (p) => {
  const izvor = (p && p.document) || {}
  const stavkeIzvora = (p && p.stavke) || []
  const strana = parseInt((p && p.documentSide), 10) || 3

  // Kolicina stoji u stupcu po strani dokumenta: ponuda 3, primka 1,
  // izdatnica 2. Servisni nalog je izdatnica (strana 2).
  const kolicina = (d) => {
    if (strana === 1) { return parseNum(d.itemPcsPlus, 2) }
    if (strana === 2) { return parseNum(d.itemPcsMinus, 2) }
    return parseNum(d.itemPcsNeutral, 2)
  }

  // Kasa racuna od BRUTO cijene (osnovica = zaPlatiti / (1 + stopa/100)), a
  // dokument drzi neto u "itemPrice". Ako gotov bruto postoji, uzima se on.
  const bruto = (d) => {
    const sPdv = parseNum(d.itemPriceWithVAT, 2)
    if (sPdv > 0) { return sPdv }
    const neto = parseNum(d.itemPrice, 2)
    const stopa = parseNum(d.itemVAT1Percentage, 2)
    return Math.round(neto * (1 + stopa / 100) * 100) / 100
  }

  const stavke = stavkeIzvora.map(d => ({
    sifra: d.ItemCode ? String(d.ItemCode) : '',
    naziv: d.itemName ? String(d.itemName) : '',
    mjera: d.itemUnit ? String(d.itemUnit) : '',
    cijena: bruto(d),
    pdvStopa: parseNum(d.itemVAT1Percentage, 2),
    usluga: d.itemService === true,
    // nabavna sluzi samo za maržu u izvjestaju kase
    nabavna: parseNum(d.itemSuppPrice, 2),
    kolicina: kolicina(d),
    popustPosto: parseNum(d.itemDiscountPercentage1, 2)
  })).filter(s => s.naziv && s.kolicina > 0)

  if (!stavke.length) {
    return {greska: 'Dokument nema stavaka koje bi se prenijele u kasu.'}
  }

  const oib = String(izvor.partnerVATID || '').trim()
  const kupac = izvor.partnerName
    ? {
      privatna: izvor.privatePerson === true,
      naziv: String(izvor.partnerName).trim(),
      oib: oib,
      mjesto: [izvor.partnerPostcode, izvor.partnerCity].filter(x => x).join(' ').trim(),
      email: izvor.partneremail ? String(izvor.partneremail).trim() : ''
    }
    : null

  return {
    stavke: stavke,
    kupac: kupac,
    // Oznaka izvora ide u napomenu racuna, osim kad je trazen cisti kopi.
    // Ide naziv na hrvatskom ("Ponuda 1"), ne interni ("QuoteSales, 1").
    izvor: (p && p.bezOznakeIzvora)
      ? ''
      : (((p && p.izvorNaziv) || izvor.documentName || '') + ' ' + (izvor.documentId || '')).trim()
  }
}

export default {pripremiKasaPrijenos}
